export const ExpandIcon = ({className, onClick}) => {
    return(
        <svg onClick={onClick} width="30" height="208" viewBox="0 0 30 208" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={{
            filter: 'drop-shadow(7px 5px 4px #63636333)'
        }}>
<path d="M0 0V208L0.521172 190.851C1.16853 169.549 7.47709 148.804 18.7983 130.748L25.3282 120.334C31.5573 110.399 31.5573 97.7793 25.3282 87.8446L18.8021 77.4364C7.47847 59.3769 1.16967 38.6272 0.5245 17.321L0 0Z" fill="white"/>
<path d="M11.5007 98.168L17.334 104.001L11.5007 109.835" stroke="#070707" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

    )
}


export const CollapseIcon = ({className, onClick}) => {
    return(
        <svg width="30" height="208" viewBox="0 0 30 208" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
<path d="M0 0V208L0.521172 190.851C1.16853 169.549 7.47709 148.804 18.7983 130.748L25.3282 120.334C31.5573 110.399 31.5573 97.7793 25.3282 87.8446L18.8021 77.4364C7.47847 59.3769 1.16967 38.6272 0.5245 17.321L0 0Z" fill="white"/>
<path d="M18.4995 98.167L12.6661 104L18.4995 109.834" stroke="#070707" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
    )
}